import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import {
  buildStandardApiErrorSwalOptions,
  DEFAULT_API_ERROR_TITLE,
  getApiErrorDetails,
} from 'src/app/shared/utils/api-error.helper';
import Swal from 'sweetalert2';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const clonedRequest = request.clone();

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        const { message } = getApiErrorDetails(
          error,
          DEFAULT_API_ERROR_TITLE,
          'Ocorreu um erro inesperado. Tente novamente.',
        );

        Swal.fire(buildStandardApiErrorSwalOptions(message));
        return throwError(() => error);
      }),
    );
  }
}
